import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import RoomServices from './roomsService';

export const AdminGetRooms = createAsyncThunk(
  'admin_room/get_room',
  async (credentials, thunkAPI) => {
    try {
      const delivered = await RoomServices.AdminGetRoom();
      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const AdminGetNormalRooms = createAsyncThunk(
  'admin_room/get_normal_room',
  async (credentials, thunkAPI) => {
    try {
      const delivered = await RoomServices.AdminGetNormalRoom();
      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const AdminUploadImages = createAsyncThunk(
  'admin_room/UploadImages',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await RoomServices.AdminUploadImages(requestData);

      return delivered;
    } catch (e) {
      throw thunkAPI.rejectWithValue(e);
    }
  }
);
